export default __webpack_public_path__ + "static/media/return.7a21a431.svg";